export const selectorCustomStyles = ({
	isDisabled,
	disabledOptions
}: {
	isDisabled?: boolean;
	disabledOptions?: boolean;
}) => ({
	control: (provided: any) => {
		return {
			...provided,
			borderRadius: 20,
			backgroundColor: isDisabled ? '#FDF1E8' : '#EEF4FD',
			border: isDisabled ? '1px solid #EDAF93' : '1px solid #799ACB',
			fontFamily: 'Poppins',
			fontSize: 11
		};
	},
	singleValue: (styles: any) => {
		return {
			...styles,
			backgroundColor: '#7899CD',
			color: 'white',
			borderRadius: 5,
			padding: '1px 10px',
			fontWeight: 'bold',
			fontFamily: 'Poppins',
			fontSize: 11
		};
	},
	singleValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 11
	}),
	multiValue: (styles: any) => ({
		...styles,
		backgroundColor: '#7899CD',
		color: 'white',
		borderRadius: 5,
		fontFamily: 'Poppins',
		fontSize: 11
	}),
	multiValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 11
	}),
	option: (provided: any, state: { isSelected: any }) => ({
		...provided,
		...(disabledOptions
			? {} // Mantener estilos para cuando esta disabled la opción (ej selector seguimiento)
			: {
					backgroundColor: state.isSelected ? '#bbcce7' : 'inherit',
					color: 'black',
					'&:hover': { backgroundColor: state.isSelected ? '#bbcce7' : 'rgb(222, 235, 255)' }
			  })
	}),
	menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
	menu: (provided: any) => ({ ...provided, zIndex: 9999, boxShadow: '0px 3px 6px #D2E2FA' })
});

export const selectorAlternativeStyles = {
	control: (provided: any) => ({
		...provided,
		borderRadius: 10,
		borderColor: '#08419B',
		fontFamily: 'Poppins',
		fontSize: 11,
		width: 300,
		'&:hover': {
			borderColor: '#08419B'
		}
	}),
	singleValue: (styles: any, ...props: any) => {
		return {
			...styles,
			backgroundColor: '#7899CD',
			color: 'white',
			borderRadius: 5,
			padding: '1px 10px',
			fontWeight: 'bold',
			fontFamily: 'Poppins',
			fontSize: 11
		};
	},
	singleValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 11
	}),
	multiValue: (styles: any) => ({
		...styles,
		backgroundColor: '#7899CD',
		color: 'white',
		borderRadius: 5,
		fontFamily: 'Poppins',
		fontSize: 11
	}),
	multiValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 11
	})
};

export const selectorCustomReducerStyles = ({
	isDisabled,
	disabledOptions,
	width = '80px', // Ajusta el ancho según sea necesario
	height = '20px' // Ajusta la altura según sea necesario
}: {
	isDisabled?: boolean;
	disabledOptions?: boolean;
	width?: string;
	height?: string;
}) => ({
	control: (provided: any) => {
		return {
			...provided,
			borderRadius: 20,
			backgroundColor: isDisabled ? '#FDF1E8' : '#EEF4FD',
			border: isDisabled ? '1px solid #EDAF93' : '1px solid #799ACB',
			fontFamily: 'Poppins',
			fontSize: 10,
			minHeight: height,
			height: 25
		};
	},
	valueContainer: (provided: any) => ({
		...provided,
		height,
		padding: '0 3px'
	}),
	input: (provided: any) => ({
		...provided,
		margin: '0px',
		fontSize: 10
	}),
	indicatorSeparator: (provided: any) => ({
		...provided,
		display: 'none',
		padding: 0
	}),
	indicatorsContainer: (provided: any) => ({
		...provided,
		height,
		padding: 0
	}),
	singleValue: (styles: any) => {
		return {
			...styles,
			backgroundColor: '#7899CD',
			color: 'white',
			borderRadius: 5,
			padding: '1px 10px',
			fontWeight: 'bold',
			fontFamily: 'Poppins',
			fontSize: 10
		};
	},
	singleValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 10
	}),
	multiValue: (styles: any) => ({
		...styles,
		backgroundColor: '#7899CD',
		color: 'white',
		borderRadius: 5,
		fontFamily: 'Poppins',
		fontSize: 10
	}),
	multiValueLabel: (styles: any) => ({
		...styles,
		color: 'white',
		fontWeight: 'bold',
		fontFamily: 'Poppins',
		fontSize: 10
	}),
	option: (provided: any, state: { isSelected: any }) => ({
		...provided,
		...(disabledOptions
			? {} // Mantener estilos para cuando esta disabled la opción (ej selector seguimiento)
			: {
					backgroundColor: state.isSelected ? '#bbcce7' : 'inherit',
					color: 'black',
					'&:hover': { backgroundColor: state.isSelected ? '#bbcce7' : 'rgb(222, 235, 255)' }
			  })
	}),
	menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
	menu: (provided: any) => ({ ...provided, zIndex: 9999, boxShadow: '0px 3px 6px #D2E2FA' })
});
